import React from 'react';
import {connect} from 'react-redux';
import {push, replace} from 'react-router-redux';
import assets from '../../../helpers/Assets';
import './TipsDialog.scss';

const mapActionCreators = {
  push,
  replace,
};

const mapStateToProps = (state, ownProps) => {
  return {
    device: state.device.current
  }
};

class TipsDialog extends React.Component {
  state = {
  }

  componentWillMount() {
  }

  componentDidMount() {
  }

  componentWillUnmount(){
  }

  componentWillReceiveProps = (newProps) => {
  }


  render = () => {
    const { succeed, title, text, btn, onConfirm, onDismiss, device } = this.props;
    const pc = device === 'pc';
    let extraStyle = { alignSelf: 'center', textAlign: 'center', fontWeight: 'bold' };
    const imgStyle = pc ? {width:'2rem', height:'auto'} : {width:'1.6rem', height:'auto'};
    return <>
      <div className="dialog_tips_container">
        <div className='dialog_tips_bg' 
          style={{width: pc ? '6.6rem' : '5.5rem'}} >
          <img alt='' style={imgStyle} src={succeed ? assets.SUCCEED : assets.FAILED}></img>
          <div className='dialog_tips_title' style={{...extraStyle, marginTop:pc ? '-.4rem' : '-.2rem'}}>{title}</div>
          <div className='dialog_tips_desc' style={extraStyle}>
            {text}
            <br/>
          </div>
          <div className='dialog_tips_btn'  style={{backgroundColor:'#1FA76D'}} onClick={onConfirm || onDismiss}>{btn || 'OK'}</div>
          <div className='dialog_tips_close' onClick={onDismiss}></div>
        </div>
      </div>
    </>
  }
}

export default connect(mapStateToProps, mapActionCreators)(TipsDialog);
